import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { DateTimeService } from 'app/shared/services/date-time/date-time.service';

@Component({
  selector: 'tog-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  providers: [DateTimeService]
})
export class TimePickerComponent implements OnInit {
  times: string[] = [
    '12:00 AM', '12:30 AM', '1:00 AM', '1:30 AM', '2:00 AM', '2:30 AM', '3:00 AM', '3:30 AM', '4:00 AM', '4:30 AM',
    '5:00 AM', '5:30 AM', '6:00 AM', '6:30 AM', '7:00 AM', '7:30 AM', '8:00 AM', '8:30 AM', '9:00 AM', '9:30 AM',
    '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM',
    '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM', '6:00 PM', '6:30 PM', '7:00 PM', '7:30 PM',
    '8:00 PM', '8:30 PM', '9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM'
  ];

  selectedTime: number;
  showError: boolean = false;

  @Input() disabled: boolean = false;

  @ViewChild('timeInput') timeInput: ElementRef;
  @Output('timeChanged') timeChanged: EventEmitter<Date> = new EventEmitter<Date>();

  constructor(public dateTimeService: DateTimeService) { }

  ngOnInit() { }

  reset() {
    this.timeInput.nativeElement.value = '';
    this.selectedTime = -1;
    this.showError = false;
  }

  setTimePickerToTime(time: Date) {
    let splitString = time.toLocaleTimeString().split(' ');
    let splitHours = splitString[0].split(':');
    let timeString = splitHours[0] + ':' + splitHours[1] + ' ' + splitString[1];

    // If selected time or typed in time is in the times array, make that the selected time
    this.selectedTime = this.times.indexOf(timeString);

    this.timeInput.nativeElement.value = timeString;
  }

  convertInputToTime(timeString: string) {
    this.showError = false;

    let time = this.dateTimeService.getDateForTimeString(timeString);
    if (!time) time = new Date();
    this.setTimePickerToTime(time);
    this.timeChanged.emit(time);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/time-picker/time-picker.component.ts